import React, { useEffect, useState } from 'react';
import { getRegistry } from '../api';
import { dollar } from '../util';
import { withAuth } from '../context/AuthContext';
import { useAudio } from '../context/AudioManagementContext';
import MoneyGame from '../component/MoneyGame';
import Dropdown from '../component/Dropdown';
import RegistryItem from '../component/RegistryItem';
import RegistryModal from '../component/RegistryModal';
import BackButton from '../component/BackButton';
import BackgroundMusic from '../component/BackgroundMusic';
import music from '../asset/sound/game1.mp3';

function Registry() {
  const { playCoin, playGem } = useAudio();
  const [registry, setRegistry] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [sort, setSort] = useState({
    label: 'CHEAPEST',
    field: 'cost',
    order: 'asc'
  });
  const [selected, setSelected] = useState(undefined);
  const [score, setScore] = useState(0);

  useEffect(() => {
    setLoading(true);
    getRegistry(
      (registry) => {
        setRegistry(registry);
        setLoading(false);
      },
      (error) => {
        setError(error);
        setLoading(false);
      },
      sort
    );
  }, [setRegistry, setLoading, setError, sort]);

  const buyItem = (cost) => {
    setScore(score - cost);
    setLoading(true);
    setRegistry([]);
    getRegistry(
      (registry) => {
        setRegistry(registry);
        setLoading(false);
      },
      (error) => {
        setError(error);
        setLoading(false);
      },
      sort
    );
  };

  const registryElements = [];
  if (!loading && registry.length) {
    for (var i = 0; i < registry.length; i++) {
      registryElements.push(
        <RegistryItem
          id={registry[i].id}
          title={registry[i].title}
          cost={registry[i].cost}
          source={registry[i].source}
          quantity={registry[i].quantity}
          key={`registry-${registry[i].id}`}
          onClick={setSelected}
        />
      );
    }
  } else if (!loading) {
    registryElements.push(<h1 key="no-results-title">NO RESULTS</h1>);
  } else {
    registryElements.push(
      <h1 className="loading" key="loading">
        LOADING...
      </h1>
    );
  }

  return (
    <div className="page registry">
      <BackButton />
      <MoneyGame
        score={score}
        setScore={setScore}
        playCoin={playCoin}
        playGem={playGem}
      />
      <h1 className="score">{dollar.format(score)}</h1>
      <div className="list-container">
        <div className="list-header">
          <h1>GIFT REGISTRY</h1>
          <Dropdown
            options={[
              { label: 'CHEAPEST', field: 'cost', order: 'asc' },
              { label: 'COSTLIEST', field: 'cost', order: 'desc' },
              { label: 'ALPHABETICAL-EST', field: 'title', order: 'asc' }
            ]}
            selectedValue={sort.label}
            onChange={setSort}
          />
        </div>
        <div className="list">
          {registryElements}
          {error}
        </div>
      </div>
      <BackgroundMusic music={music} volume={1} />
      <RegistryModal
        show={selected !== undefined}
        onClose={() => setSelected(undefined)}
        id={selected}
        score={score}
        buyItem={buyItem}
      />
    </div>
  );
}

export default withAuth(Registry);
